export enum AnalyticsEvent {
  OnboardingStart = "onboarding_start",
  AuthSkip = "auth_skip",
  AuthIntent = "auth_intent",
  AuthOtp = "auth_otp",
  SubscriptionStatus = "subscription_status",
  BundleCodeActivate = "bundle_code_activate",
  PaywallView = "paywall_view",
  PaywallSelect = "paywall_select",
  TvLinkGrant = "tv_link_grant",
  TvLinkAttempt = "tv_link_attempt",
  ProfileSetup = "profile_setup",
  HomepageAction = "homepage_action",
  NavbarAction = "navbar_action",
  GameSelect = "game_select",
  GameBuy = "game_buy",
  GameViewIgdb = "game_view_igdb",
  GameLaunchStart = "game_launch_start",
  GameLaunchStep = "game_launch_step",
  GameLaunchFailed = "game_launch_failed",
  GameLaunchComplete = "game_launch_complete",
  GameOverlayAction = "game_overlay_action",
  GamePerformanceWarning = "game_performance_warning",
  GameSessionEnd = "game_session_end",
  SubscriptionCancel = "subscription_cancel",
  SubscriptionTransaction = "subscription_transaction",
}

interface IUserProperties {
  sub_status?: string;
  controllers?: number;
}

export const GTM_ID = "GTM-5QLW93VX";

export interface IAnalyticsParams {
  event_name: AnalyticsEvent;
  user_id?: string;
  user_properties?: IUserProperties;
  source?: string;
  type?: string;
  value?: string | number;
  game_session_id?: string;
  session_time?: string;
  status?: string;
  error?: string;
}
